import { EmailLine24, PushLine24, SmsLine24 } from 'ui/icons/aurora';
import { TabsGroup } from 'ui/tabsGroup';
import {
  ButtonText,
  StyledNavTabsList,
  StyledNavTrigger,
  Wrapper,
} from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/BreakdownTabs.styles';
import { MessageMediumTabs } from 'modules/intelligentInsights/frequencyOptimization/types';
import { BreakdownTabsContent } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/BreakdownTabsContent';
import { useFroInsightsCoreContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/CoreContext';

export const BREAKDOWN_TAB_TEST_ID = 'breakdown-tab-trigger';

export const BreakdownTabs = () => {
  const { selectedMedium, setSelectedMedium } = useFroInsightsCoreContext();
  return (
    <Wrapper>
      <TabsGroup
        value={selectedMedium}
        onValueChange={(newTab) => setSelectedMedium(newTab as MessageMediumTabs)}
      >
        <StyledNavTabsList>
          <StyledNavTrigger
            data-test={`${MessageMediumTabs.Email}-${BREAKDOWN_TAB_TEST_ID}`}
            key={MessageMediumTabs.Email}
            value={MessageMediumTabs.Email}
          >
            <EmailLine24 />
            <ButtonText>{MessageMediumTabs.Email}</ButtonText>
          </StyledNavTrigger>
          <StyledNavTrigger
            data-test={`${MessageMediumTabs.Push}-${BREAKDOWN_TAB_TEST_ID}`}
            key={MessageMediumTabs.Push}
            value={MessageMediumTabs.Push}
          >
            <PushLine24 />
            <ButtonText>{MessageMediumTabs.Push}</ButtonText>
          </StyledNavTrigger>
          <StyledNavTrigger
            data-test={`${MessageMediumTabs.SMS}-${BREAKDOWN_TAB_TEST_ID}`}
            key={MessageMediumTabs.SMS}
            value={MessageMediumTabs.SMS}
          >
            <SmsLine24 />
            <ButtonText>{MessageMediumTabs.SMS}</ButtonText>
          </StyledNavTrigger>
        </StyledNavTabsList>
        <BreakdownTabsContent />
      </TabsGroup>
    </Wrapper>
  );
};
